export default {
  dockPanel: '机场',
  rcPanel: '遥控器',
  noDrone: '无飞行器',
  currentProject: '当前项目',

  switchProjectFailed: '切换项目失败',
  noAvailableDock: '找不到可用机场设备',

  dockNotConnected: '机场未连接，无法打开详情面板',
  deviceNotConnected: '飞行器未连接，无法打开详情面板',
  hideDetailPanel: '隐藏详情面板',
  showDetailPanel: '查看详情面板',

  noAlarm: '暂无告警',
  alarmTitle: '告警',
  alarmCount: '共 {count} 条',
  close: '关闭',
  confirmRead: '确认已读',
  viewAllAlarms: '查看全部 {count} 条告警',
  workspaceNotFoundForHms: '未找到工作区，无法标记已读',
  confirmReadSuccess: '已确认已读',
  markReadFailed: '标记已读失败',

  deviceMode: {
    0: '待机',
    1: '起飞准备',
    2: '起飞准备完毕',
    3: '手动飞行',
    4: '自动起飞',
    5: '航线飞行',
    6: '全景拍照',
    7: '智能跟随',
    8: 'ADS-B 躲避',
    9: '自动返航',
    10: '自动降落',
    11: '强制降落',
    12: '三桨叶降落',
    13: '升级中',
    14: '未连接',
    15: 'APAS',
    16: '虚拟摇杆状态',
    17: '指令飞行',
  },

  dockMode: {
    disconnected: '未连接',
    0: '空闲中',
    1: '现场调试',
    2: '远程调试',
    3: '固件升级中',
    4: '作业中',
  },
}
